<template>
  <div>
    <!--
    <b-form-radio-group
      id="priceRanges"
      v-model="selectedPriceRange"
      :options="priceRangesOptions"
      buttons
      class="btn-group-sm"
    />
     -->
    <search-price-slider />
  </div>
</template>

<script>
// import SearchPriceRanges from 'components/SearchPriceRanges.vue';
import SearchPriceSlider from 'components/SearchPriceSlider.vue';
import searchRedirect from 'mixins/composition/search/SearchFunctions';

// import { BFormRadioGroup } from 'bootstrap-vue';

export default {
  name: 'FilterPriceRange',
  components: {
    // SearchPriceRanges,
    SearchPriceSlider,
    // BFormRadioGroup,
  },
  i18nOptions: { namespaces: 'filter' },
  setup() {
    return {
      searchRedirect,
    };
  },
  data() {
    return {
      selectedPriceRange: {},
    };
  },
  computed: {
    priceRanges() {
      return this.$store.getters.getPriceAggregation;
    },
    priceRangesOptions() {
      const priceRangesOptions = [];
      Object.keys(this.priceRanges).forEach((range) => {
        priceRangesOptions.push({ text: this.$t(`filter:priceRanges.${range}`), value: range, title: 'test' });
      });
      return priceRangesOptions;
    },
  },
  watch: {
    selectedPriceRange(priceRange) {
      searchRedirect({
        router: this.$router,
        filters: {
          priceMin: this.priceRanges[priceRange][0],
          priceMax: this.priceRanges[priceRange][1],
        },
      });
    },
  },
};
</script>
